"use client";
import styled from "../../../client-utils/styled/index.js";
import CardMenu from "../../../components/atoms/CardMenu/index.js";
import CardMenuItem from "../../../components/atoms/CardMenuItem/index.js";
import LinkAtom from "../../../components/atoms/Link/index.js";
import SkeletonAtom from "../../../components/atoms/Skeleton/index.js";
const coreComponentName = "SdbCardButton";
export const Root = styled(CardMenu, { name: coreComponentName, slot: "Root" })({
    padding: 0,
});
export const Item = styled(CardMenuItem, { name: coreComponentName, slot: "Item" })({
    minHeight: 72,
});
export const Link = styled(LinkAtom, { name: coreComponentName, slot: "Link" })({
    textDecoration: "none",
    color: "inherit",
});
export const Skeleton = styled(SkeletonAtom, { name: coreComponentName, slot: "Skeleton" })({
    minHeight: 72,
});
